var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "full-loader" }, [
      _c("div", { staticClass: "loader loader-primary" }, [
        _c(
          "div",
          {
            staticClass: "spinner-border spinner-border-sm text-secondary",
            attrs: { role: "status" },
          },
          [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }